export default "__VITE_ASSET__C_eHHi3S__"